import { Component, OnInit, Input, Output, EventEmitter, Renderer2 } from '@angular/core';
import { Carrier } from '../carrier/carrier';
import { CarrierService } from '../carrier/carrier.service';
import { ErrorHandler } from "../utils/error-handler"
import { MessagesService } from '../messages/messages.service';
import { TubeRackValidationRequest } from './TubeRackValidationRequest';
import { TubeRackService } from './tube-rack.service';
import { CarrierUtility } from '../utils/carrier-utility';

@Component({
  selector: 'app-tube-rack',
  templateUrl: './tube-rack.component.html',
  styleUrls: ['./tube-rack.component.css']
})
export class TubeRackComponent implements OnInit {


  @Input() selectedCarrier: Carrier;
  @Input() storeLocationForHamiltonRack: string;
  errorHandler: ErrorHandler = new ErrorHandler;
  @Output() updatedCarrierEmitter = new EventEmitter();
  @Output() focusLocationEmitterForHamiltonRack = new EventEmitter();
  blocked = false;
  cachedBarcode: string;
  tubeRackValidationRequest: TubeRackValidationRequest = new TubeRackValidationRequest();
  carrierUtil: CarrierUtility = new CarrierUtility();


  constructor(private renderer: Renderer2, private _carrierService: CarrierService, private messagesService: MessagesService, private tubeRackService: TubeRackService) { }

  ngOnInit() {
    this.rowColumns = [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31];
  }

  ngAfterViewInit() {
    if (this.storeLocationForHamiltonRack) {
      setTimeout(() => {
        var elem = this.renderer.selectRootElement('#' + this.storeLocationForHamiltonRack);
        this.renderer.listen(elem, "focus", () => { });
        elem.focus();
      }, 0);
    }
  }
  rowColumns: number[];

  // makes focus on the next input box
  onEnterMaterialBarcode(i, item: Carrier) {
    // 31 is the maximum index of the hamilton rack
    i == 31 ? i = 0 : i = i + 1;
    if (i <= 31) {
      let focusLocation = 'textBox-' + item._id + i;
      this.focusLocationEmitterForHamiltonRack.emit(focusLocation);
      document.getElementById('textBox-' + item._id + i).focus();
    }
  }


  materialRemoved(barcode: string): boolean {
    if (barcode === "" && this.cachedBarcode != "") {
      return true;
    }
    return false;
  }

  cacheBarcode(barcode: string, i) {
    this.cachedBarcode = barcode;

  }

  saveMaterial(barcode: string, i, j, carrier: Carrier) {

    let barcodeWithoutEmptySpace = barcode.replace(/\s/g, "").trim()
    if (this.materialRemoved(barcode) || (barcodeWithoutEmptySpace != "" && barcodeWithoutEmptySpace != this.cachedBarcode)) {
      this.blocked = true;
      this.tubeRackValidationRequest.carrierRef = carrier._id;
      this.tubeRackValidationRequest.carrierBarcode = carrier.barcode.replace(/\s/g, "").trim();
      this.tubeRackValidationRequest.materialBarcode = barcodeWithoutEmptySpace
      this.tubeRackValidationRequest.positionRow = i + 1;
      this.tubeRackValidationRequest.positionCol = j + 1;
      this.tubeRackValidationRequest.labId = carrier.lab._id;
      this.tubeRackValidationRequest.removeMaterial = this.materialRemoved(barcode);
      this.tubeRackService.getCarrierByMaterialBarcode(this.tubeRackValidationRequest).subscribe(
        result => {
          if (!result) {
            return;
          }

          this.selectedCarrier = result.data;
          this.updatedCarrierEmitter.emit(result.data);
          this.blocked = false;
        },
        error => {
          setTimeout(() => {
            var elem = this.renderer.selectRootElement('#' + 'textBox-' + this.selectedCarrier._id + i);
            this.renderer.listen(elem, "focus", () => { });
            elem.focus();
            this.renderer.setStyle(elem, "color", "red");
          }, 0);

          let message = this.errorHandler.handleError(error);
          this.messagesService.addErrorMessage(message);
          this.blocked = false;
        })
    }
  }
  private getCarrierItemBarcode(i: number, j: number, selectedCarrier: Carrier): string {

    if (this.carrierUtil.getCarrierItemBarcode(i, j, selectedCarrier) != null
      && this.carrierUtil.getCarrierItemBarcode(i, j, selectedCarrier) != "")
      return this.carrierUtil.getCarrierItemBarcode(i, j, selectedCarrier);

    else
      return this.carrierUtil.getCarrierItemErrorBarcode(i, j, selectedCarrier);
  }
}
